import {errorReporter} from 'hudl-base';
window.onerror = errorReporter.sendError;

import 'components/team-profile-page/team-profile-page';
